import axios from "./AxiosInstance"

export const login = (payload) => axios.post("api/login_check", { ...payload })

export const LoginService = {
    login
}
